/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

// Typist CSS
import 'react-typist/dist/Typist.css'; // https://github.com/gatsbyjs/gatsby/issues/17719